"use strict";

import ReportService from './ReportService.js'

export var reportService = new ReportService();